import { 
    Flex, 
    Text,
    Button,
    Image,
    useMediaQuery,
    useTheme,
    Link
} from '@chakra-ui/react';
import banner from '../assets/images/banner-01.png';
import logo from '../assets/icons/logo.svg';
import logoGuia from '../assets/icons/logo-guia.svg';
import fb from '../assets/icons/facebook-bn.svg';
import ig from '../assets/icons/instagram-bn.svg';

const Presentacion = () => {
    const { breakpoints } = useTheme();
    const [isGreaterThanMd] = useMediaQuery(`(min-width: ${breakpoints.md})`);

    return (
        <Flex
            w="100%"
            h="100vh"
            id="fondo"
            flexDirection={"column"}
            backgroundImage={`url(${banner})`}
            backgroundSize="cover"
            backgroundPosition={isGreaterThanMd ? "center center" : "end"}
            backgroundRepeat="no-repeat"
            backgroundColor="gray.100"
            p="0">
                <Flex w="100%" marginTop={'2.5rem'} flexDirection={isGreaterThanMd ? "row" : "column"}>
                    <Flex w={isGreaterThanMd ? '50%' : '100%'}>
                        <Image src={logo} w={isGreaterThanMd ? 211 : 121} h={51} alt='logo' ml={10} mr={10} />
                        <Link zIndex={"1"} href='https://grupoguia.mx/' isExternal>
                            <Image src={logoGuia} w={isGreaterThanMd ? 195 : 115} h={29} mt={4} alt='logo' />
                        </Link>
                    </Flex>
                    <Flex w={isGreaterThanMd ? '50%' : '100%'} display={isGreaterThanMd ? "flex" : "none"} justifyContent={"end"}>
                        <Button
                            fontSize={'20px'}
                            fontWeight={700}
                            variant={'link'}
                            bg={'#fff'} mr={10}
                            color={'#302C7D'} as='a'
                            w={145} h={34}
                            padding={2} paddingLeft={4} paddingRight={4}
                            href={'https://grupoguia.mx/'}
                            borderRadius='none'
                            display={{ base: 'none', md: 'flex' }}
                            _hover={{
                                bg: '#EEEEEE',
                            }}
                            >
                            Regresar
                        </Button>
                    </Flex>
                </Flex>
                <Flex flexDirection={"column"} color={"#545454"} pl={10} pt={5}>
                    <Text fontSize={isGreaterThanMd ? '28px' : '20px'} lineHeight={"initial"} fontWeight={700} mb={3}>Guía y morhada se unen para entregarte<br />tu casa o depa totalmente amueblados</Text>
                    <Text fontSize={isGreaterThanMd ? '22px' : '18px'} lineHeight={"initial"} fontWeight={'light'}>Compra tu propiedad con nosotros y morhada se<br />encargará de equiparla con todo lo que necesitas para<br />comenzar a disfrutar tus rentas ¡desde hoy mismo!</Text>
                </Flex>
                <Flex flexDirection={"column"} color={"#545454"} pl={10} pb={10} height={'100%'} justifyContent={"end"}>
                    <Link zIndex={"1"} href='https://www.facebook.com/profile.php?id=100084924907179&mibextid=ZbWKwL' isExternal mb={2}>
                        <Image src={fb} w={isGreaterThanMd ? '12px' : '10px'} h={'28px'} alt='logo' ml={1} />
                    </Link>
                    <Link zIndex={"1"} href='https://instagram.com/morhadamx?igshid=NmE0MzVhZDY=' isExternal>
                        <Image src={ig} w={isGreaterThanMd ? '20px' : '16px'} h={'20px'} alt='logo' />
                    </Link>
                </Flex>
        </Flex>
    );
}

export default Presentacion;